import { getLatestVersion } from "@/utils/firebase/firestore-version";
import { isVersionMin } from "@/utils/versions";
import { isDev } from "@/utils/debug/is-dev";

export const checkVersion = async (forced = false) => {
    try {
        // Limit checks for preset minutes
        const delay = isDev ? 0.1 : 30;
        if (!forced && localStorage.getItem('lastVersionCheck')) {
            if (Date.now() - localStorage.getItem('lastVersionCheck') < (delay * 60 * 1000)) {
                return;
            }
        }

        const data = await getLatestVersion("webapp");
        if (data !== null) localStorage.setItem('lastVersionCheck', Date.now());
        if (data !== null && !isVersionMin(window.appVersion, data.version)) forceUpdate(data.version);
    } catch(e) {
        window.captureException(e);
    }
}

const forceUpdate = (version) => {
    window.location.replace(window.location.protocol + "//" + window.location.host + "/index.html?packageName=" + window.packageName + "&v=" + version);
}
